(() => {
  if (window.YoLinkProductBuying) return;
  const instances = new Map();
  const init = root => {
    if (instances.has(root)) return;
    const count = Number(root.dataset.ylPackCount);
    const summary = root.querySelector('[data-yl-order-summary]');
    if (!summary || !Number.isSafeInteger(count) || count < 1) return;
    const form = root.querySelector('.yl-product-form');
    const quantity = form?.querySelector('[name="quantity"]');
    const variantInput = form?.querySelector('[name="id"]');
    const data = root.querySelector('[data-yl-product-json]');
    if (!quantity || !variantInput || !data) return;
    let product, money;
    try {
      product = JSON.parse(data.textContent);
      if (!Array.isArray(product.variants)) return;
      money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: root.dataset.ylCurrency,
      });
    } catch { return; } // Optional summary must not break the native purchase form.
    const selected = root.querySelector('[data-yl-selected-pack]');
    const format = cents => money.format(cents / 100);
    const setSelectedText = (selector, text) => {
      const node = selected?.querySelector(selector);
      if (node) node.textContent = text;
    };
    const update = () => {
      const id = variantInput.value;
      const variant = product.variants.find(item =>
        (typeof item?.id === 'number' || typeof item?.id === 'string') && String(item.id) === String(id));
      const validPrice = Number.isSafeInteger(variant?.price) && variant.price >= 0;
      const packs = Number(quantity.value);
      if (!validPrice) {
        summary.textContent = 'Merchandise total unavailable for the selected variant.';
      } else if (!Number.isSafeInteger(packs) || packs < 1 || !Number.isSafeInteger(packs * count) || !Number.isSafeInteger(packs * variant.price)) {
        summary.textContent = 'Enter a whole number of packs, at least 1, to see your total.';
      } else {
        const units = packs * count;
        summary.textContent = `${packs} ${packs === 1 ? 'pack' : 'packs'} · ${units} ${units === 1 ? 'sensor' : 'sensors'} · ${format(packs * variant.price)} merchandise total`;
      }
      if (selected) {
        setSelectedText('[data-yl-pack-price]', validPrice ? `${format(variant.price)} / pack` : 'Price unavailable');
        setSelectedText('[data-yl-unit-price]', validPrice ? `${format(Math.round(variant.price / count))} / sensor` : 'Price unavailable');
        setSelectedText('[data-yl-pack-stock]', typeof variant?.available === 'boolean'
          ? (variant.available ? 'In stock' : 'Currently unavailable') : 'Availability unavailable');
      }
    };
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    window.addEventListener('pageshow', update);
    root.dataset.ylBuyingReady = 'true';
    instances.set(root, () => {
      form.removeEventListener('input', update);
      form.removeEventListener('change', update);
      window.removeEventListener('pageshow', update);
      delete root.dataset.ylBuyingReady;
      instances.delete(root);
    });
    update();
  };
  const scan = () => document.querySelectorAll('[data-yl-product-root]').forEach(init);
  window.YoLinkProductBuying = { scan };
  scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, dispose] of instances) if (event.target.contains(root)) dispose();
  });
})();
